import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";

function PaymentInProgress() {
  const navigate = useNavigate();

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <Spinner animation="border" role="status" className="mb-3">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <h3>Plaćanje u tijeku...</h3>
          <p>
            Platite u novoj kartici koja se automatski otvorila. Nakon završetka
            plaćanja, vratite se na dashboard.
          </p>
          <Button variant="primary" onClick={() => navigate("/dashboard")}>
            Vratite se na Dashboard
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default PaymentInProgress;
